import React from "react";
import SimpleMatchSummary from "./SimpleMatchSummary";
import { getPrettyDate } from "../lib/format";

const SimplePoolItem = ({ item }) => {
  return (
    <div>
      <div className="pooldateindicator4R">
        {getPrettyDate(item.programDate)} - {item.PartitionKey} - Betting Closes: {item.kickOffTime}
      </div>
      <table className="pooltable">
        <tbody>
          <tr>
            <th>Match</th>
            <th>Team A</th>
            <td style={{ textAlign: "center" }}>v</td>
            <th className="righttext">Team B</th>
          </tr>
          {JSON.parse(item.matches).map((match) => (
            <SimpleMatchSummary key={match.mnum} item={match} pool_title={item.PartitionKey} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SimplePoolItem;
